import { resizeImageFile } from "./imageResize";

export const uploadAndResizeImage = async (
    file: File,
    albumName: string,
    isBackgroundImage = false,
    saveOriginal = false,
    token?: string // <-- new optional parameter
): Promise<{
    originalUrl: string;
    smallUrl: string;
}> => {
    if (!file) throw new Error("No file provided for upload");
    if (!albumName) throw new Error("No albumName provided");

    // Use passed token or fallback to localStorage (for main thread)
    const authToken = token ?? localStorage.getItem("token");
    if (!authToken) throw new Error("No auth token found");

    const API_URL = process.env.REACT_APP_API_URL;
    const maxWidth = isBackgroundImage ? 1500 : 1000;

    // Resize image
    const smallBlob = await resizeImageFile(file, maxWidth);
    const smallFile = new File([smallBlob], file.name, { type: "image/jpeg" });

    // --- Upload small ---
    const smallForm = new FormData();
    smallForm.append(isBackgroundImage ? "fileBackgroundSmall" : "fileSmall", smallFile);

    const smallRes = await fetch(`${API_URL}/upload/small`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "x-album-name": encodeURIComponent(albumName),
        },
        body: smallForm,
    });

    if (!smallRes.ok) {
        const text = await smallRes.text();
        throw new Error(`Small upload failed: ${text}`);
    }
    const { smallUrl } = await smallRes.json();

    // --- Upload original ---
    const originalForm = new FormData();
    originalForm.append(isBackgroundImage ? "fileBackgroundOriginal" : "file", file);

    const originalRes = await fetch(`${API_URL}/upload/original`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "x-album-name": encodeURIComponent(albumName),
        },
        body: originalForm,
    });

    if (!originalRes.ok) {
        const text = await originalRes.text();
        throw new Error(`Original upload failed: ${text}`);
    }
    const { originalUrl } = await originalRes.json();

    return { smallUrl, originalUrl };
};
